






























































































































































































































































































































































import Vue from 'vue';
import { EventBus } from '@/event-bus';

import { iconsMixin } from '@/mixins/icons';
import { authMixin } from '@/mixins/auth';
import { breakpointsMixin } from '@/mixins/breakpoints';

import { SavePendingOrderResponse } from '@/models/shipments/addOrEdit/responses/SavePendingOrderResponse';
import { SaveShipmentRequest } from '@/models/shipments/addOrEdit/requests/SaveShipmentRequest';
import { Quote } from '@/models/quotes/Quote';
import { Filter } from '@/models/quotes/search/Filter';
import { Account } from '@/models/Account';
import DropdownOption from '@/models/misc/DropdownOption';
import User from '../../models/User';

import quoteService from '@/services/QuoteService';
import carrierService from '@/services/CarrierService';
import accountService from '@/services/AccountsService';
import pendingOrderService from '@/services/PendingOrderService';
import sessionStorageService from '@/services/SessionStorageService';
import exportService from '@/services/ExportService';
import settingService from '@/services/SettingService';
import domService from '@/services/DOMService';
import miscService from '@/services/MiscService';

export default Vue.extend<any, any, any, any>({
  mixins: [iconsMixin, authMixin, breakpointsMixin],
  data() {
    return {
      pageSize: 10,
      quotes: [] as Quote[],
      page: [] as Quote[],
      loading: false as Boolean,
      currentPage: 1,
      rerenderUsers: 0,

      snackbar: false,
      snackbarText: '',
      displayFilters: false,
      displayDetails: false,
      booking: false,
      selectedQuote: null as Quote,

      showFilters: true,
      extendedOptions: new Filter(),
      selectedCarriers: [] as DropdownOption[],
      carriersDdl: [] as DropdownOption[],
      dateMenu: false,
      users: [] as User[],
      accounts: [] as Account[],
      selectedUsername: '' as string,
      selectedAccount: '' as string,
      selectedUser: new User(),
      createdDate: '',
      accountsDdl: [] as DropdownOption[],

      showEmailQuotePopup: false,
      emailTemplateData: null,
      emailingQuoteData: null,
      savedFilter: null,
      parcelQuotesOnlyEnabled: false,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.savedSearch();
      EventBus.$on('quotes-quick-search', this.search);

      this.populateCarriers();
      this.populateAccounts();
      this.populateUsers();
      this.setParcelQuotesOnlyEnabled();
    },
    populateCarriers() {
      carrierService.getAllActive().then((x) => {
        this.carriersDdl = x
          .filter((x) => x.name != '')
          .map(
            (x) =>
              new DropdownOption(this.getNormalizedCarrierName(x.name), x.id)
          );

        this.setSavedCarriers();
      });
    },
    csvExport() {
      exportService.csvDownload(this.quotes, 'My Quotes');
    },
    setParcelQuotesOnlyEnabled() {
      settingService
        .getSystemSetting(
          'PARCEL_QUOTES_ONLY',
          this.user.accountId,
          this.user.userId
        )
        .then((x: any) => {
          if (x) {
            this.parcelQuotesOnlyEnabled = x?.value?.toLowerCase() == 'true';
          }
        });
    },
    setSavedCarriers() {
      if (this.savedFilter) {
        this.savedFilter.carriers.forEach((x) => {
          const carrier = this.carriersDdl.find((y) => y.value == x);
          if (carrier) {
            this.selectedCarriers.push(carrier);
          }
        });
      }
    },
    openVltlQuotesSearch() {
      miscService.goToPage('/customer/quotes/volume');
    },
    populateUsers(account) {
      let accountId = this.user.accountId;
      if (account?.value) {
        accountId = account.value;
      }

      if (!this.extendedOptions) {
        this.extendedOptions = new Filter();
      }
      this.extendedOptions.accountId = accountId;

      this.usersDdl = [];
      if (accountId) {
        accountService.getUsers(accountId).then((x: User[]) => {
          this.usersDdl = x.map(this.mapUser);
          this.users = x;

          // clear user selection
          this.selectedUser = new User();
          this.selectedUsername = '';

          this.setSavedUser();
        });
      }
    },
    populateAccounts() {
      accountService.getAllAccounts().then((x) => {
        this.accountsDdl = x.map(this.mapAccount);
        this.accounts = x;

        this.setSavedAccount();
      });
    },
    mapAccount(account: Account) {
      return new DropdownOption(
        this.getNormalizedAccountName(account.company),
        account.accountId
      );
    },
    setSavedUser() {
      if (this.savedFilter && this.savedFilter.userId) {
        const user = this.usersDdl.find(
          (x) => x.value == this.savedFilter.userId
        );
        if (user) {
          this.selectedUsername = user.text;
        }
      }
    },
    setSavedAccount() {
      if (this.savedFilter && this.savedFilter.accountId) {
        const account = this.accountsDdl.find(
          (x) => x.value == this.savedFilter.accountId
        );
        if (account) {
          this.selectedAccount = account.text;
        }
      }
    },
    savedSearch() {
      this.savedFilter = sessionStorageService.get('quotes-search-options');
      this.search(this.savedFilter);

      this.extendedOptions = this.savedFilter;
      this.createdDate = this.savedFilter?.createdDate;

      const accountId = this.savedFilter?.accountId;
      const userId = this.savedFilter?.userId;
      if (accountId) {
        accountService.getAllAccounts().then((x) => {
          const account = x.find((x) => x.accountId == accountId);
          if (account) {
            this.selectedAccount = account.company;
          }
        });
      }

      if (userId) {
        accountService.getUsers(accountId).then((x: User[]) => {
          const user = x.find((x) => x.userId == userId);
          if (user) {
            this.selectedUsername = user.firstName + ' ' + user.lastName;
          }
        });
      }
    },
    book(saveShipmentRequest: SaveShipmentRequest) {
      this.booking = true;
      pendingOrderService
        .create(saveShipmentRequest)
        .then((x: SavePendingOrderResponse) => {
          const justCreatedOrderId = x.orderId;

          this.booking = false;

          if (justCreatedOrderId) {
            window.location.href =
              '/customer/shipment/' + justCreatedOrderId + '/edit';
          }
        })
        .catch((x) => {
          this.booking = false;
          console.error(x);
        });
    },
    emailSent() {
      this.snackbarText = `Email has been sent to the customer`;
      this.snackbar = true;
    },
    openEmailForm(data) {
      this.emailTemplateData = data;
      this.showEmailQuotePopup = true;
    },
    mapUser(user: User) {
      return new DropdownOption(
        user.firstName + ' ' + user.lastName,
        user.userId ?? ''
      );
    },
    createdDateChanged() {
      this.extendedOptions.createdDate = this.createdDate;
      this.updateFilter();

      setTimeout(() => {
        this.$refs.datePickerField?.focus();
      }, 100);
    },
    carrierSelected() {
      this.extendedOptions.carriers = this.selectedCarriers.map((x) => x.value);
      this.updateFilter();
    },
    updateFilter() {
      EventBus.$emit('quotes-update-filter', this.extendedOptions);
    },
    /* istanbul ignore next */
    toggleFilters() {
      if (!this.extendedOptions) {
        this.extendedOptions = new Filter();
      }

      this.showFilters = !this.showFilters;
    },
    showDetails(details: Quote) {
      this.selectedQuote = details;

      this.displayDetails = true;

      setTimeout(() => {
        window.scroll({
          behavior: 'smooth',
          left: 0,
          top: document.getElementsByTagName('body')[0].offsetTop,
        });
      }, 200);
    },
    pageChange(newPage: number) {
      this.page = this.quotes.slice(
        (newPage - 1) * this.pageSize,
        newPage * this.pageSize
      );
    },
    /*istanbul ignore next*/
    copied(quoteId: Number) {
      navigator.clipboard.writeText(quoteId.toString());
      this.snackbarText = `Quote ${quoteId} has been copied to the clipboard`;
      this.snackbar = true;
    },
    userChanged(selected: DropdownOption) {
      this.extendedOptions.userId = selected?.value;
      this.updateFilter();
    },
    setUserId(options) {
      if (this.bookingAgent || !this.viewOthersShipQuotes) {
        const userId = this.user.userId;
        // or not a company admin user
        if (options && userId) {
          options.userId = userId;
        }

        if (this.extendedOptions && userId) {
          this.extendedOptions.userId = userId;
        }
      }
    },
    search(options: Filter) {
      console.log(`Searching quotes with options: `, options);
      this.rerenderUsers++;
      this.loading = true;

      if (options && this.user.accountId) {
        options.accountId = this.user.accountId;
      }

      const accountNotSet =
        this.extendedOptions && !this.extendedOptions.accountId;
      if (accountNotSet) {
        this.extendedOptions.accountId = this.user.accountId;
      }

      if (options && !options.accountId) {
        options.accountId = this.extendedOptions.accountId;
      }

      this.setUserId(options);
      if (options && !options.userId) {
        options.userId = this.extendedOptions.userId;
      }

      const filter = options ?? this.extendedOptions;
      const preSavedAcccountId = this.savedFilter?.accountId
        ? this.savedFilter?.accountId + ''
        : null;
      setTimeout(() => {
        if (!filter.accountId && preSavedAcccountId) {
          filter.accountId = preSavedAcccountId;
        }

        quoteService.list(filter).then((x: Quote[]) => {
          this.quotes = x;
          this.page = this.quotes.slice(0, this.pageSize);
          this.loading = false;
        });

        domService.bodyClick();
      }, 500);

      // save search
      sessionStorageService.set('quotes-search-options', filter);
    },
    clearFilters() {
      // clear quick search filters
      EventBus.$emit('quotes-clear-filter');

      // clear extended filters
      this.extendedOptions = new Filter();
      this.selectedCarriers = [];
      this.createdDate = '';
      this.selectedUsername = '';
      this.selectedAccount = '';
      this.selectedUser = new User();

      // search
      this.search(null);
    },
    getNormalizedCarrierName(str) {
      if (!str) return '';
      if (
        str.toUpperCase().includes('UPS') ||
        str.toUpperCase().includes('AFS') ||
        str.toUpperCase().includes('FEDEX')
      )
        return str;

      return str.replace(/\b\w+\b/g, function (word) {
        if (word.length <= 3 && word.toUpperCase() != 'INC') return word;
        if (word.toUpperCase() == 'ASAP') return word;

        // Otherwise, capitalize the first letter and lowercase the rest
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      });
    },
    getNormalizedAccountName(str) {
      if (!str) return '';
      if (str.toUpperCase().includes('UPS')) return str;

      return str.replace(/\b\w+\b/g, function (word) {
        if (word.length <= 3 && word.toUpperCase() != 'INC') return word;
        if (word.toUpperCase() == 'ASAP') return word;

        // Otherwise, capitalize the first letter and lowercase the rest
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      });
    },
  },
  computed: {
    parcelQuotesOnlyEnabledComputed() {
      return this.parcelQuotesOnlyEnabled;
    },
    emailTemplate() {
      return this.emailTemplateData;
    },
    emailingQuote() {
      return this.emailingQuoteData;
    },
    showNoData() {
      return !this.loading && (!this.page || !this.page.length);
    },
    newQuoteBtnCss() {
      let className = 'fr ';

      if (this.smAndDown) {
        className += 'w-100-pct';
      }

      return className.trim();
    },
  },
});
